const SCHEDULE_OFFICE_COLUMN_DEFS = [
  { id: "schedule_id", label: "ID", defaultVisible: true },
  { id: "schedule_date", label: "Date", defaultVisible: true },
  { id: "schedule_time", label: "Time", defaultVisible: true },
  { id: "schedule_title", label: "Title", defaultVisible: true },
  { id: "assigned_to_name", label: "Assigned To", defaultVisible: true },
  { id: "priority_name", label: "Priority", defaultVisible: true },
  { id: "status", label: "Status", defaultVisible: true },
  { id: "actions", label: "Action", defaultVisible: true },
];

const SCHEDULE_ADMIN_COLUMN_DEFS = [
  { id: "schedule_id", label: "Schedule ID", defaultVisible: true },
  { id: "schedule_date", label: "Date", defaultVisible: true },
  { id: "schedule_time", label: "Time", defaultVisible: true },
  { id: "schedule_title", label: "Title", defaultVisible: true },
  { id: "schedule_type_name", label: "Schedule Type", defaultVisible: true },
  { id: "assigned_to_name", label: "Assigned To", defaultVisible: true },
  { id: "priority_name", label: "Priority", defaultVisible: true },
  { id: "status", label: "Status", defaultVisible: true },
  { id: "created_by_name", label: "Created By", defaultVisible: true },
  { id: "actions", label: "Action", defaultVisible: true },
];

export function getScheduleColumnDefs(isAdmin) {
  return isAdmin ? SCHEDULE_ADMIN_COLUMN_DEFS : SCHEDULE_OFFICE_COLUMN_DEFS;
}
